import { useState } from "react";
import { useLocation } from "react-router-dom";
// @mui
import { Box, Collapse, List } from "@mui/material";
// type
import { NavListProps } from "../type";
//
import { getActive } from "..";
import { NavItemRoot, NavItemSub } from "./NavItem";

// ----------------------------------------------------------------------

type NavListRootProps = {
  list: NavListProps;
  isCollapse: boolean;
  handleOpenModuleDialog;
};

export function NavListRoot({
  list,
  isCollapse,
  handleOpenModuleDialog,
}: NavListRootProps) {
  const { pathname } = useLocation();
  const hasChildren = list.children;
  const active = getActive(list.path, pathname, !!hasChildren);
  const [open, setOpen] = useState(active);
  if (hasChildren) {
    return (
      <>
        <NavItemRoot
          item={list}
          isCollapse={isCollapse}
          active={active}
          open={open}
          onOpen={() => setOpen(!open)}
          handleOpenModuleDialog={handleOpenModuleDialog}
        />

        {!isCollapse && (
          <Collapse in={open}>
            <List component="div" disablePadding>
              {(list.children || []).map((item, index) => (
                <Box key={index}>
                  {item.role && (
                    <NavListSub
                      key={item.title + item.path}
                      list={item}
                      handleOpenModuleDialog={handleOpenModuleDialog}
                    />
                  )}
                </Box>
              ))}
            </List>
          </Collapse>
        )}
      </>
    );
  }

  return (
    <NavItemRoot
      item={list}
      active={active}
      isCollapse={isCollapse}
      handleOpenModuleDialog={handleOpenModuleDialog}
    />
  );
}

// ----------------------------------------------------------------------

type NavListSubProps = {
  list: NavListProps;
  handleOpenModuleDialog;
};

function NavListSub({ list, handleOpenModuleDialog }: NavListSubProps) {
  const { pathname } = useLocation();
  const hasChildren = list.children;
  const active = getActive(list.path, pathname, !!hasChildren);
  const [open, setOpen] = useState(active);
  if (hasChildren) {
    return (
      <>
        <NavItemSub
          item={list}
          onOpen={() => setOpen(!open)}
          open={open}
          active={active}
          handleOpenModuleDialog={handleOpenModuleDialog}
        />

        <Collapse in={open} timeout="auto">
          <List component="div" disablePadding sx={{ pl: 3 }}>
            {(list.children || []).map((item) => (
              <NavItemSub
                key={item.title + item.path}
                item={item}
                active={getActive(item.path, pathname)}
                handleOpenModuleDialog={handleOpenModuleDialog}
              />
            ))}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <NavItemSub
      item={list}
      active={active}
      handleOpenModuleDialog={handleOpenModuleDialog}
    />
  );
}
